<template>
  <div class="new-password-container login-container">
      <div class="limiter">
        <div class="container-login100">
          <div class="wrap-login100">
            <div class="login100-pic" data-tilt>
              <img :src="require('@/assets/img-01.png')" alt="IMG" />
            </div>
            <el-form :model="passwordForm" status-icon :rules="passwordRules" ref="passwordForm">
              <span class="login100-form-title"> Choose a new password </span>
              <el-alert
                v-if="errMsg"
                title="Create new password error"
                type="error"
                :description="errMsg"
                show-icon>
              </el-alert>
              <el-form-item prop="password" label="New password">
                <el-input type="password" v-model="passwordForm.password" placeholder="New password" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item prop="confirm_password" label="Repeat your new password">
                <el-input type="password" v-model="passwordForm.confirm_password" placeholder="Repeat your password" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item>
                <div class="container-login100-form-btn">
                  <el-button :loading="loading" class="login100-form-btn" type="primary" @click="SendNewPassword">Change password</el-button>
                </div>

              </el-form-item>
            </el-form>

          </div>
        </div>
      </div>
  </div>
</template>

<script>
import {resetPassword} from '@/api/user'
export default {
  data(){
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please input the password'));
        } else {
          if (this.passwordForm.confirm_password !== '') {
            this.$refs.passwordForm.validateField('confirm_password');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please input the password again'));
        } else if (value !== this.passwordForm.password) {
          callback(new Error('Two inputs don\'t match!'));
        } else {
          callback();
        }
      };
    return{
      errMsg: '',
      loading: false,
      passwordForm: {
        password: '',
        confirm_password: ''
      },
      passwordRules: {
        
        password: [{ validator: validatePass, trigger: "blur" }],
        confirm_password: [{ validator: validatePass2, trigger: "blur" }],
       
      },
    }
  },
  methods: {
    SendNewPassword(){
      this.$refs.passwordForm.validate((valid) => {
        if(valid){
          this.loading = true
          this.errMsg = ''
          resetPassword(this.$route.params.token, this.passwordForm).then(({result, message}) => {
                       
            if(result){
              this.$message({
                showClose: true,
                message: message,
                type: 'success'
              });
              setTimeout(()=>{
                this.loading = false
                this.$router.push({ path: '/login' })
              }, 2000)
              
            }else{
              this.loading = false
              this.errMsg = message
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/login.scss";
.new-password-container{
  .el-form-item__content {
    line-height: 30px;
    position: relative;
    font-size: 14px;
  }
  .el-form-item {
      margin-bottom: 16px;
  }
}
</style>